export const MODULE_NAME = 'digital-payments-travel-wishlist-root';

export const IDLE = 'idle';
export const LOADING = 'loading';
export const ERROR = 'error';
export const SUCCESS = 'success';
